module.exports = __webpack_public_path__ + "4a6303f20f3864d4af9b191ffef032ad.pdf";